import { BRANDS, determineBrandFromURL } from '../helpers/brand';
import { setCookieTypeAndValue, setCookieDropdownValue, setCookieCombinedButtonValue } from '../helpers/util';
import { breakpoints } from '../helpers/breakpoints';
import { CookieType, CurrencyValues } from '../helpers/enums';

export const initialCurrencyAndCountry = () => {
  const brand = determineBrandFromURL();

  const countryCookie = document.cookie.match(new RegExp(`(^| )${CookieType.COUNTRY}=([^;]+)`));

  const currencyCookie = document.cookie.match(new RegExp(`(^| )${CookieType.CURRENCY}=([^;]+)`));

  const currentCookieCurrency = currencyCookie ? currencyCookie[2].toUpperCase() : null;

  const openCurrencyPicker = () => {
    if (window.innerWidth < breakpoints.screen1024) {
      const nav = document.querySelector('[js-nav-open]') as HTMLElement;
      if (nav) {
        nav.click();

        setTimeout(() => {
          const currencyPicker = document.querySelector('[js-custom-currency-button]') as HTMLElement;
          currencyPicker.click();
        }, 1000);
      }
    } else {
      const currencyPicker = document.querySelector('[js-custom-combined-currency-button]') as HTMLElement;
      if (currencyPicker) {
        currencyPicker.click();
      }
    }
  };

  const convertCurrenyDataToJSON = (currencyData: NodeListOf<HTMLElement>) => {
    const convertedData: {
      code: string;
      countries: string[];
    }[] = [];
    if (currencyData.length > 0) {
      currencyData.forEach((currency) => {
        const code = currency.getAttribute('js-currency-country-data-code') as string;

        const countries = currency.getAttribute('js-currency-country-data-countries') as string;

        convertedData.push({
          code,
          countries: countries.toUpperCase().split(',')
        });
      });
    }
    return convertedData;
  };

  const currencyCountryData = convertCurrenyDataToJSON(document.querySelectorAll('[js-currency-country-data]'));

  const currencyIsCurrentlySelectable = currencyCountryData.some(
    ({ code }) => currentCookieCurrency && currentCookieCurrency.toUpperCase() === code.toUpperCase()
  );

  if (currencyCookie && !currencyIsCurrentlySelectable) {
    openCurrencyPicker();
  }

  const fetchLocationData = async () => {
    let country: string = 'IE';
    let currency: string = CurrencyValues.EUR;

    const convertDefaultCurrenyDataToJSON = (currencyData: NodeListOf<HTMLElement>) => {
      const convertedData: {
        code: string;
      }[] = [];
      if (currencyData.length > 0) {
        currencyData.forEach((currency) => {
          const code = currency.getAttribute('js-hotel-default-currency-code') as string;
          convertedData.push({
            code
          });
        });
      }
      return convertedData;
    };

    const defaultHotelCurrencyData = convertDefaultCurrenyDataToJSON(
      document.querySelectorAll('[js-hotel-default-currency]')
    );

    try {
      const response = await fetch(
        `${brand == BRANDS.STAYCITY ? 'https://www.staycity.com' : 'https://www.wilde.com'}/geolookup`
      );
      const data = await response.json();
      if (data) {
        if (!data?.country || data?.country == 'XX') {
          openCurrencyPicker();
        } else {
          country = data.country;
        }
      }
    } catch (err) {
      openCurrencyPicker();
    }

    if (currencyCountryData?.length) {
      const currencyObject = currencyCountryData.find(({ countries }) => countries.includes(country.toUpperCase()));
      if (currencyObject) {
        currency = currencyObject?.code;
      } else {
        if (defaultHotelCurrencyData?.length) {
          currency = defaultHotelCurrencyData[0].code;
        }
      }
    } else {
      if (defaultHotelCurrencyData?.length) {
        currency = defaultHotelCurrencyData[0].code;
      }
    }

    if (currency && country) {
      setCookieTypeAndValue(CookieType.CURRENCY, currency.toLowerCase());
      setCookieTypeAndValue(CookieType.COUNTRY, country.toLowerCase());
      setCookieTypeAndValue(CookieType.LOCATION_CURRENCY, currency.toLowerCase());
      setCookieDropdownValue(CookieType.CURRENCY);
      setCookieCombinedButtonValue(CookieType.CURRENCY);
    } else {
      openCurrencyPicker();
    }
  };

  if (!countryCookie) {
    fetchLocationData();
  }
};
